
import moment from 'moment';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  Connection, PermissionCode, User,
} from '@/types';
import DatePicker from '@/components/DatePicker.vue';

moment.locale('it');

@Component({
  components: {
    DatePicker,
  },
})
export default class ConnectionMUP1RequestDate extends Vue {
  @Prop(Object) readonly connection!: Connection;

  loading = false

  // Il valore utilizzato e gestito nel DatePicker
  // nel formato '2023-02-24'
  mup1RequestDate: string | null = null;

  created() {
    // console.log(`${this.constructor.name}: created()`); // eslint-disable-line no-console

    // Trasforma il Date in '2023-02-24T23:00:00.000Z' poi in '2023-02-24'
    this.mup1RequestDate = this.mup1RequestDateValue
      ? moment(this.mup1RequestDateValue).toISOString(true).substring(0, 10)
      : null;
  }

  // Il valore di tipo Date memorizzato nel DB
  get mup1RequestDateValue(): Date | null {
    return this.connection?.mup1RequestDate ?? null;
  }

  // Se il valore memorizzato nel DB cambia...
  @Watch('mup1RequestDateValue')
  onValue(val: Date | null) {
    // ... aggiorna il valore gestito dal DatePicker
    console.log(`${this.constructor.name}: onValue()`); // eslint-disable-line no-console

    // Trasforma il Date in '2023-02-24T23:00:00.000Z' poi in '2023-02-24'
    this.mup1RequestDate = val
      ? moment(val).toISOString(true).substring(0, 10)
      : null;
  }

  get mup1RequestDateString(): string | null {
    return this.mup1RequestDate
      && moment(this.mup1RequestDate).isValid()
      ? moment(this.mup1RequestDate).format('L')
      : null;
  }

  get user(): User { return this.$store.getters.currentUser; }
  get userPermissions(): PermissionCode[] { return this.$store.getters.currentUserPermissions; }
  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  get isDisabled() {
    return this.loading;
  }

  get isEditable() {
    if (!this.connection) return false;

    return this.connection
      && (this.connection.status === 'open' || this.connection.status === 'new')
      && this.hasPermission('mup1RequestDate.edit');
  }

  get columnClass(): string {
    // Se presente la data colora la colonna di verde
    return this.mup1RequestDate !== null ? 'green' : '';
  }

  async onSelect(newValue: Date | null) {
    console.log(`${this.constructor.name}: onSave() newValue =`, newValue); // eslint-disable-line no-console

    // Assegna il valore in modo che sia subito mostrato quello aggiornato
    // anche se effettivamente non è ancora stato salvato.
    // Trasforma il Date in '2023-02-24T23:00:00.000Z' poi in '2023-02-24'
    this.mup1RequestDate = newValue
      ? moment(newValue).toISOString(true).substring(0, 10)
      : null;

    // Prepara l'aggiornamento
    const update = {
      mup1RequestDate: newValue,
    } as { [key: string]: unknown };

    // Disabilita il campo e richiede l'aggiornamento.
    // Verrà riabilitato ad aggiornamento completato.
    this.loading = true;
    await this.$store.dispatch('updateConnectionFields', {
      id: this.connection?.id,
      fields: update,
      force: true,
    });
    this.loading = false;
  }
}

